import { useCallback, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserAPI as getUserAPIV2 } from "@modules/apis/user-management-v2";

const useUserDetail = () => {
    const dispatch = useDispatch();

    const stage = useSelector(({ stage }) => stage);
    const project = useSelector(({ project }) => project);

    const [userProfileAnchorEl, setUserProfileAnchorEl] = useState(null);
    const [userId, setUserId] = useState(null);
    const [userProfileData, setUserProfileData] = useState(null);
    const [userProfilePending, setUserProfilePending] = useState(false);
    const [openUserProfile, setOpenUserProfile] = useState(false);

    const handleUserProfileClose = (event) => {
        event.stopPropagation();
        setUserProfileData(null);
        setUserProfileAnchorEl(null);
        setOpenUserProfile(false);
    };

    const getUserInfo = useCallback(async () => {
        try {
            setUserProfilePending(true);
            const { data } = await getUserAPIV2(stage.id, stage.endpoint, project.id, userId);
            const userData = { ...data?.idp?.userInfo, name: data?.name, username: data?.username };

            setUserProfileData(userData);
            setUserProfilePending(false);
            setOpenUserProfile(Boolean(userProfileAnchorEl));
        } catch (error) {
            console.log(error);
        }
    }, [userProfileAnchorEl, userId, stage, project]);

    const handleUserProfileClick = (event, id) => {
        event.stopPropagation();
        setUserId(id);
        setUserProfileAnchorEl(event.currentTarget);
    };

    useEffect(() => {
        if (!userProfileAnchorEl || !userId) return;
        getUserInfo();
    }, [userProfileAnchorEl, userId]);

    return {
        handleUserProfileClick,
        handleUserProfileClose,
        userProfileAnchorEl,
        openUserProfile,
        userProfileData,
        userProfilePending,
    };
};

export default useUserDetail;
